import { render, staticRenderFns } from "./ProdelecPostModal.vue?vue&type=template&id=9c9e525a&scoped=true&"
import script from "./ProdelecPostModal.vue?vue&type=script&lang=ts&"
export * from "./ProdelecPostModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProdelecPostModal.vue?vue&type=style&index=0&id=9c9e525a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9e525a",
  null
  
)

export default component.exports